import React, { useMemo } from 'react';
import {
    AssistanceAlertBar,
    AssistanceHeaderBackButton,
    AssistanceHeaderControls,
    AssistanceHeaderPagination,
    AssistanceHeaderTitleGroup,
    AssistanceHeaderViewsToggle,
} from '../../../document/pages/Assistance/components/AssistanceHeader.tsx';
export const LIST_OF_SERVICE_ASSISTANCE_MODES = {
    EDITOR: 'EDITOR',
    SUMMARY: 'SUMMARY',
};

export enum RelevanceSelectionState {
    RELEVANT_OPEN = 'RELEVANT_OPEN',
    RELEVANT_COMPLETED = 'RELEVANT_COMPLETED',
    IRRELEVANT_OPEN = 'IRRELEVANT_OPEN',
    IRRELEVANT_COMPLETED = 'IRRELEVANT_COMPLETED',
}

export const getActivePositionFilters = (filters: RelevanceSelectionState[]): RelevanceSelectionState[] => {
    return filters.filter((filter) => filter !== undefined && filter !== null);
};

const ListOfServicesAssistanceHeader = () => {
    return (
        <>
            <div className="flex items-center px-4 py-2 gap-4 border-b border-solid border-line-weak">
                <div className="flex justify-between items-center flex-1 gap-2 min-w-0">
                    <div className="flex items-center">
                        <AssistanceHeaderBackButton />
                        <AssistanceHeaderTitleGroup />
                    </div>
                    <AssistanceHeaderViewsToggle />
                </div>

                <AssistanceHeaderControls hideOriginalDataButton />

                <div className="h-6 border-r border-solid border-line-weak" />

                <AssistanceHeaderPagination />
            </div>

            <AssistanceAlertBar />
        </>
    );
};

export default ListOfServicesAssistanceHeader;
